(ns admin.events.containers.activity-moments
  "Responsible for bootstrapping the activity moments page."
  (:require [kyber.router :refer [ensure-resource-v2]]
            [kyber.events.eql :as eql]
            [kyber.events.utils :refer [kyber-event-fx]]
            [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]))

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-success
    {:description "Get activity moments page (Success)"
     :changelog
     [{:date "15APR21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-success
  [{:keys [db]} [event-name {:keys [curriculum-uuid activity-uuid]} res]]
  (let [curriculum (get res [:curriculum/uuid curriculum-uuid])
        activity (get res [:activity/uuid activity-uuid])]
    {:db (cond-> db
           (some? curriculum) (kyber-db/tx-record  {:model :curriculum} curriculum)
           (some? activity) (kyber-db/tx-record  {:model :activity} activity))
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]}))

(kyber-event-fx ::fetch-container-data-success fetch-container-data-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-failure
    {:description "Get activity moments page (Failure)"
     :changelog
     [{:date "15APR21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-failure
  [{:keys [db]} [event-name _ _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-failure fetch-container-data-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data
    {:description "Get activity moments page"
     :changelog
     [{:date "15APR21"
       :event-version 0
       :data {}}]}))

(def base-resource-keys
  [:activity/uuid
   :resource/uuid
   :resource/created-at
   :resource/created-by
   :resource/data-type
   :resource/download-key
   :resource/download-path
   :resource/duration
   :resource/description
   :resource/failed?
   :resource/file-name
   :resource/file-size
   :resource/file-type
   :resource/learner-engaged
   :resource/learning-objective
   :resource/name
   :resource/page-count
   :resource/page-dimensions
   :resource/poster
   :resource/processing?
   :resource/source-key
   :resource/source-path
   :resource/status
   :resource/url
   :resource/m3u8
   :resource/viewer-key
   :resource/viewer-path])

(def base-moment-keys
  [:moment/uuid
   :moment/valid
   :moment/admin-message
   :moment/xfdf-id
   :moment/page-number
   :moment/start-time
   :moment/y1
   {:moment/valid-tags
    [:content-provider.tag-group/uuid
     :content-provider.tag-group/name
     :content-provider.tag-group/description
     {:content-provider.tag-group/values
      [:content-provider.tag/uuid
       :content-provider.tag/name]}]}
   {:moment/question
    [:question/uuid
     :question/type
     :question/key?
     :question/body
     {:question/choices [:question.choice/body
                         :question.choice/correct-answer
                         :question.choice/uuid]}
     :question/created-at
     :question/has-correctness
     :question/educator-feedback]}
   :moment/type
   :moment/end-time
   :moment/behavior
   :moment/title
   :moment/xfdf
   :moment/activity
   :moment/display-at
   :moment/highlighted-resource
   :moment/x1
   :moment/y2
   :moment/body
   :moment/confidence
   :moment/include-poll-data
   :moment/resources
   :moment/x2
   :moment/required
   :moment/halo-rects
   {:moment/learning-objective
    [:learning-objective/uuid
     :learning-objective/description
     :learning-objective/label]}
   :moment/hide-at])

(defn fetch-container-data
  [{:keys [db]} [event-name {:keys [curriculum-uuid activity-uuid] :as params}]]
  {:db (cond-> db
         (some? curriculum-uuid)
         (kyber-db/retract-record {:model :curriculum} {:curriculum/uuid curriculum-uuid})

         (some? activity-uuid)
         (kyber-db/retract-record {:model :activity} {:activity/uuid activity-uuid}))
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request
   (eql/request
    db
    {:name event-name
     :params `[{[:curriculum/uuid ~curriculum-uuid]
                [:curriculum/uuid
                 :curriculum/name
                 {:curriculum/resources ~base-resource-keys}]}
               {[:activity/uuid ~activity-uuid]
                [:activity/uuid
                 :activity/name
                 :activity/created-at
                 :activity/plo-type
                 :activity/published
                 :activity/ai-enabled
                 {:activity/primary-learning-object ~base-resource-keys}
                 {(:activity/moments {:include-invalid? true}) ~base-moment-keys}
                 {(:activity/resources {:include-plo? true}) ~base-resource-keys}
                 {:activity/learning-objectives
                  [:learning-objective/uuid
                   :learning-objective/label
                   :learning-objective/description]}
                 {:activity/valid-tags
                  [:content-provider.tag-group/uuid
                   :content-provider.tag-group/name
                   :content-provider.tag-group/description
                   {:content-provider.tag-group/values
                    [:content-provider.tag/uuid
                     :content-provider.tag/name]}]}]}]
     :on-success [::fetch-container-data-success params]
     :on-failure [::fetch-container-data-failure params]})})

(kyber-event-fx ::fetch-container-data fetch-container-data)

(def ensure-activity-moments
  ""
  (partial ensure-resource-v2 ::fetch-container-data
           #(re-frame/dispatch [::fetch-container-data %])))
